import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
  selector: 'date-tag',
  imports: [],
  templateUrl: './date-tag.component.html',
  styleUrls: ['./date-tag.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateTagComponent {
  text = input.required<string>()
}
